function getCartCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}

async function addProductToCart(product, quantity) {
    // Vérifier si c'est l'abonnement et s'il est déjà dans le panier
    const subscriptionVariantId = 53270006464844;
    if (product == subscriptionVariantId) {
        const cartData = await fetchCartJS();
        const alreadyInCart = cartData.items.some(item => item.id == subscriptionVariantId);
        if (alreadyInCart) {
            console.log('L\'abonnement est déjà dans le panier, ajout annulé');
            return true; // Retourner success car le produit est déjà là
        }
    }

    
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ 
                id: product, 
                quantity: quantity || 1
            })
        });
    
        return response;
}

async function clearCart() {
    const clearResponse = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json','X-Requested-With': 'XMLHttpRequest'}
        });
    
}

function displayMessage(message, containerId) {
    let messageContainer = document.getElementById(containerId);
  
    if (typeof message === "object") {
        messageContainer.textContent = Object.values(message).join("<br>");
    } else {
        messageContainer.textContent = message;
    }
}

async function fetchCartJS(){
    const response = await fetch('/cart.js')
    const data = await response.json();
    return data; // Retourner l'objet complet du panier avec items ET attributes
}

async function getCustomerIp(){
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
}

async function getProductMetaData(productId){
    const response = await fetch(`/cart?view=meta-data.json`);
    const data = await response.json();
    return data;
}

function generateHash(data, secretKey) {
    const hash = CryptoJS.SHA256(data + secretKey);
    return hash.toString(CryptoJS.enc.Hex);
}

function hideLoading(idButton, idLoader) {
    const button = document.getElementById(idButton)
    const loader = document.getElementById(idLoader)

    if (button && loader) {
        button.disabled = false;
        button.style.opacity = '1';
        loader.style.display = 'none';
    }
}

function showLoading(idButton, idLoader) {
    const button = document.getElementById(idButton)
    const loader = document.getElementById(idLoader)

    if (button && loader) {
        button.disabled = true;
        button.style.opacity = '0.3';
        loader.style.display = 'block';
    }
}

function setSessionStorage(name, value, maxAge = null) {
    const data = {
      value: value,
      timestamp: Date.now()
    };
    if (maxAge !== null) {
      data.maxAge = maxAge * 1000; // Convertir en millisecondes
    }
    sessionStorage.setItem(name, JSON.stringify(data));
}

function getSessionStorage(name) {
    try {
      const item = sessionStorage.getItem(name);
      if (!item) return null;
      
      const data = JSON.parse(item);
      const now = Date.now();
      
      // Vérifier si l'élément a expiré
      if (data.maxAge && (now - data.timestamp) > data.maxAge) {
        sessionStorage.removeItem(name);
        return null;
      }
      
      return data.value;
    } catch (e) {
      console.warn('Erreur lors de la lecture du sessionStorage:', e);
      return null;
    }
}

async function getAccountCustomerData(email, orderId){
    try {
        const payload = {
            email: email.trim(),
            orderId: orderId.trim(),
            timestamp: Date.now()
        };

        const apiConfig = getApiConfig();
        const response = await fetch(apiConfig.url_account, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        const text = await response.text();
        const sessionData = JSON.parse(text);
        
        if (sessionData && !sessionData.error) {
            const dataForSession = {
                data: sessionData,
                email: email,
                orderId: orderId,
                _ts: Date.now()
            };
            setSessionStorage('accountCustomerData', JSON.stringify(dataForSession), 3600);
            return dataForSession;
        }

        return sessionData;
        
    } catch (err) {
        console.error('Erreur getAccountCustomerData:', err);
        return { error: 'Erreur de connexion au serveur' };
    }
}


async function saveChoice(attributesVariable, choiceValue) {
    try {
      // Ajouter l'attribut au panier via le formulaire
      const form = document.getElementById('CartDrawer-Form');
      if (!form) {
        console.error('Formulaire CartDrawer-Form introuvable');
        return false;
      }
      
      // Supprimer l'ancien input s'il existe
      const existingInput = form.querySelector('input[name="attributes[' + attributesVariable + ']"]');
      if (existingInput) {
        existingInput.remove();
      }
      
      // Créer le nouvel input
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[' + attributesVariable + ']';
      input.value = choiceValue.toString();
      form.appendChild(input);
      
      // Soumettre le formulaire pour sauvegarder l'attribut
      const formData = new FormData(form);
      const response = await fetch('/cart', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        console.log('Choix d\'abonnement sauvegardé:', choiceValue);
        return true;
      } else {
        console.error('Erreur lors de la sauvegarde du choix d\'abonnement');
        return false;
      }
    } catch (error) {
      console.error('Erreur dans saveSubscriptionChoice:', error);
      return false;
    }
}

async function FacebookAddToCart() {
    const productMetaData = await getProductMetaData();
    if (productMetaData && productMetaData.meta_product_id_array) {
        let productIDs = [];
        let totalPrice = 0.00;
        let contentNames = [];
        let contentCategories = [];

        productMetaData.meta_product_id_array.forEach((item) => {
            let productId = item.id.includes(".") ? item.id.split(".")[0] : item.id;
            let productPrice = item.is_subscription ? 0.00 : item.price / 100;
            productIDs.push(productId);
            contentNames.push(item.product_title || '');
            contentCategories.push(item.product_type || '');
            totalPrice += parseFloat(productPrice);
        });

        const eventData = {
            value: totalPrice,
            currency: 'EUR',
            content_ids: productIDs,
            content_type: 'product'
        };

        if (!Array.isArray(window.pixelConfigs) || window.pixelConfigs.length === 0) {
            console.warn("pixelConfigs non défini ou vide");
            return;
        }

        const clientIP = await getCustomerIp();

        window.pixelConfigs.forEach(({ pixelId, accessToken }) => {
            fetch(`https://graph.facebook.com/v18.0/${pixelId}/events?access_token=${accessToken}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    data: [{ 
                        event_name: "AddToCart",
                        event_time: Math.floor(new Date().getTime() / 1000),
                        action_source: "website",
                        user_data: {
                            client_ip_address: clientIP,
                            client_user_agent: navigator.userAgent
                        },
                        custom_data: {
                            currency: "EUR",
                            value: parseFloat(totalPrice.toFixed(2)),
                            content_ids: productIDs,
                            content_type: "product",
                            content_name: contentNames.join(', '),
                            content_category: contentCategories.join(', '),
                            num_items: productIDs.length
                        }
                    }]
                })
            })
            .then(response => response.json())
            .then(data => console.log("Facebook AddToCart Response:", data))
            .catch(error => console.error("Facebook AddToCart API Error:", error));
        });
    }
}

// Initialisation du tracking Facebook
document.addEventListener('DOMContentLoaded', function() {
    if (typeof $ !== 'undefined') {
        $(document).on('click', '[type="submit"][name="add"]', function() {
            if (typeof FacebookAddToCart === 'function') {
                FacebookAddToCart();
            }
        });
    }
});